import React, { useState } from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Routes } from './routes/routes';
import './App.css';
import './App.scss';
import { history } from './app/store';
import {Dialog} from './components/dialog/dialog';
import {Toolbar} from './components/toolbar/toolbar';
import { InitializeContainer } from './containers/initialize';
import { ConnectionStatusBar } from './components/ui/connection-status-bar/connection-status-bar';
import { Env } from './models/env';
import { V2Recaptcha } from './components/ui/recaptcha-v2/recaptcha-v2';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { SystemConfig } from './hooks/system-config';

const App = () => {

  const [initialized, setInitialized] = useState(false);

  return initialized ? (
    <GoogleReCaptchaProvider reCaptchaKey={Env.recaptcha.v3SiteKey}>
      <ConnectedRouter history={history} >
        <Routes />
        <SystemConfig />
      </ConnectedRouter>
      <Dialog />
      <Toolbar />
      <ConnectionStatusBar />
      <V2Recaptcha />
      {/* <LoadingBar /> */}
    </GoogleReCaptchaProvider>
  ) : (
    <InitializeContainer onInitialized={() => {
      setInitialized(true);
    }} />
  );
}

export default App;
